import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { logout } from '../redux/actions/authActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBars, faTachometerAlt, faHourglass, faExclamationCircle, faPowerOff, faSignInAlt, faTimes, faDashboard, faUser, faQuestionCircle, faMobileScreen, faHandsClapping,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons';
import AppMenu from './AppMenu';
import logo from '../assets/navlogo.png';
import { motion } from "framer-motion";

const Navbar = () => {
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);

  const toggleNavbar = () => {
    setIsNavbarOpen(!isNavbarOpen);
  };

  const [logoutConfirm, setLogoutConfirm] = useState(false);
  const handleLogoutClick = () => {
    setLogoutConfirm(true);
  };

  const handleConfirmLogoutClick = () => {
    dispatch(logout());
    setLogoutConfirm(false); 
  };

  const handleCancelLogoutClick = () => {
    setLogoutConfirm(false);
  };

  const handleHomeClicked = () => {
    navigate("/my-profile-home");
  };

  const handleDashboardClicked = () => {
    navigate("/dashboard");
  };

  const handleAdminDashboardClicked = () => {
    navigate("/admindashboard");
  };

  const handleAboutThink5WhysClicked = () => {
    navigate("/about-think5whys-home");
  };
  

  return (
    <>
      <header className='flex justify-between sticky top-0 p-4 bg-darkblue bg-gray-700 text-white [&_p]:text-gray-100 shadow-sm items-center sm:max-w-full border-b-2 border-cyan-200 mb-2'>
        <div className="flex flex-col">
          <div className="flex justify-between items-center">
            {/* <Link to="/"><img src={logo} alt="Logo" className="logo" /></Link> */}
            <Link to="/">
              <motion.img
                src={logo}
                alt="Logo"
                style={{ width: 50 }}
                animate={{ y: [0, -5, 0], scale: [1, 1.05, 1] }}
                transition={{ duration: 2, repeat: Infinity }}
              />
            </Link>
            <h1 className="cursor-pointer text-yellow-300">
              <Link 
                to="/" 
                className="text-yellow-300 uppercase" 
                style={{ fontSize: '1.25rem' }}>
                Think5Whys
                <sup style={{ fontSize: '0.75rem', color: 'red' }}>Beta</sup>
              </Link><br/>
              <p className="text-white" style={{ fontSize: '0.70rem' }}>
                {authState.user && authState.user.name ? authState.user.name : 'Welcome Guest'}
              </p>
            </h1>
          </div>
        </div>
        <div>
          <ul className='hidden md:flex gap-4 uppercase font-small justify-between'>
            {authState.isLoggedIn && (
              <>
                <li className="bg-blue-500 text-white hover:bg-blue-600 font-small rounded-md">
                  <Link to='/dashboard' className='block w-full h-full px-1 py-2'>
                    <FontAwesomeIcon icon={faTachometerAlt} style={{ marginRight: '5px' }} />Home
                  </Link>
                </li>
                <li className="bg-blue-500 text-white hover:bg-blue-600 font-small rounded-md">
                  <Link to='/admindashboard' className='block w-full h-full px-1 py-2'>
                    <FontAwesomeIcon icon={faMobileScreen} style={{ marginRight: '5px' }} />Admin
                  </Link>
                </li>
                <li className="bg-blue-500 text-white hover:bg-blue-600 font-small rounded-md">
                  <Link to='/rcas/add' className='block w-full h-full px-1 py-2'>
                    <FontAwesomeIcon icon={faExclamationCircle} style={{ marginRight: '5px' }} />Think5Whys
                  </Link>
                </li>
                <li className="bg-blue-500 text-white hover:bg-blue-600 font-small rounded-md">
                  <Link to='/tasks/add' className='block w-full h-full px-1 py-2'>
                    <FontAwesomeIcon icon={faHourglass} style={{ marginRight: '5px' }} />Chronicles
                  </Link>
                </li>
                <li className="bg-blue-500 text-white hover:bg-blue-600 font-small rounded-md">
                  <Link to='/applause/add' className='block w-full h-full px-1 py-2'>
                    <FontAwesomeIcon icon={faHandsClapping} style={{ marginRight: '5px' }} />Applause
                  </Link>
                </li>
                <li className="bg-blue-500 text-white hover:bg-blue-600 font-small rounded-md">
                  <Link to='/my-profile-home' className='block w-full h-full px-1 py-2'>
                    <FontAwesomeIcon icon={faUser} style={{ marginRight: '5px' }} /> Profile
                  </Link>
                </li>
                <li className='bg-red-800 text-white py-2 px-1 cursor-pointer hover:bg-red-600 transition rounded-sm' onClick={handleLogoutClick}>
                  <FontAwesomeIcon icon={faPowerOff} style={{ marginRight: '1px' }} />
                </li>
                {logoutConfirm && (
                  <div className="absolute right-4 w-64 p-1 bg-white border border-gray-300 shadow-lg rounded-lg z-1000">
                    <div className="flex justify-between">
                      <button
                        className="bg-red-600 text-white px-2 rounded-md hover:bg-red-700"
                        onClick={handleConfirmLogoutClick}
                      >
                        Logout
                      </button>
                      <button
                        className="bg-gray-300 text-gray-700 px-2 rounded-md hover:bg-gray-400"
                        onClick={handleCancelLogoutClick}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                )}
              </>
            )}
          </ul>
        </div>

        {/* Navbar displayed as sidebar on smaller screens */}
        {!authState.isLoggedIn && (
          <div className='py-2 px-3 cursor-pointer bg-green-800 text-white hover:bg-green-900 transition rounded-sm'>
            {/* <Link to="/login"> */}
            <span>
              <FontAwesomeIcon icon={faSignInAlt} style={{ marginRight: '5px' }} />Login
            </span>              
            {/* </Link> */}
          </div>
        )}

        {authState.isLoggedIn && (
          <>
            <button
              className='md:hidden cursor-pointer focus:outline-none'
              style={{
                background: 'blue',
                border: 'none',
                width: 'fit-content',
                fontSize: '24px',
              }}
              onClick={toggleNavbar}
            >
              <FontAwesomeIcon icon={faBars} />
            </button>
            <div className={`fixed inset-y-0 right-0 md:hidden bg-gray-200 w-full md:w-64 z-50 transform transition-transform ease-in-out ${isNavbarOpen ? 'translate-x-0' : 'translate-x-full'}`} style={{ height: '100vh' }}>
              <div className="flex justify-between items-center py-0">
                <button className="text-red-400 bg-gray-200" onClick={toggleNavbar}>
                  <FontAwesomeIcon icon={faTimesCircle} style={{ fontSize: '24px' }} />
                </button>
                <button className="text-blue-800 bg-gray-200" onClick={handleHomeClicked}>
                  <FontAwesomeIcon icon={faUser} style={{ fontSize: '24px' }} />
                  </button>
                <button className="text-blue-800 bg-gray-200" onClick={handleDashboardClicked}>
                  <FontAwesomeIcon icon={faMobileScreen} style={{ fontSize: '24px' }} />
                  </button>
                <button className="text-blue-800 bg-gray-200" onClick={handleAdminDashboardClicked}>
                  <FontAwesomeIcon icon={faDashboard} style={{ fontSize: '24px' }} />
                  </button>
                <button className="text-red-700 bg-gray-200" onClick={handleLogoutClick}>
                  <FontAwesomeIcon icon={faPowerOff} style={{ fontSize: '24px' }} />
                </button>
                {logoutConfirm && (
                  <div className="absolute right-2 w-64 p-1 bg-white border border-gray-300 shadow-lg rounded-lg z-1150">
                    <div className="flex justify-between">
                      <button
                        className="bg-red-600 text-white px-4 py-2 rounded-md hover:bg-red-700"
                        onClick={handleConfirmLogoutClick}
                      >
                        Logout
                      </button>
                      <button
                        className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-400"
                        onClick={handleCancelLogoutClick}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                )}
              </div>
              <div className='w-full flex item-center justify-between py-0 px-3 cursor-pointer bg-blue-800 text-white hover:bg-green-900 transition rounded-sm'>
                <Link to="/rcas/add" className='sticky-menu-item'><FontAwesomeIcon icon={faExclamationCircle} style={{ marginRight: '8px' }} />+5Whys</Link>
                <Link to="/tasks/add" className='sticky-menu-item'><FontAwesomeIcon icon={faHourglass} style={{ marginRight: '8px' }} />+Chronicle</Link>
                <Link to="/applause/add" className='sticky-menu-item'><FontAwesomeIcon icon={faHandsClapping} style={{ marginRight: '8px' }} />+Applause</Link>
              </div>
              <div className='flex justify-center'>
                <AppMenu />
              </div>
            </div>
          </>
        )}
      </header>
    </>
  );
}

export default Navbar;

//Do not delete 
{/* <div className={`fixed inset-y-0 right-0 md:hidden bg-gray-200 w-64 z-50 transform transition-transform ease-in-out ${isNavbarOpen ? 'translate-x-0' : 'translate-x-full'}`} style={{ height: '100vh' }}>
  <div className="flex justify-between items-center py-0">
    <button className="text-red-400 bg-gray-200" onClick={toggleNavbar}>
      <FontAwesomeIcon icon={faTimesCircle} style={{ fontSize: '24px' }} />
    </button>
    {/* <Link to='/my-profile-home' className="text-blue-700 bg-gray-200 mt-0">
      <FontAwesomeIcon icon={faUser} style={{ fontSize: '24px' }} />
    </Link>
    <Link to='/dashboard' className="text-blue-700 bg-gray-200 ml-4">
      <FontAwesomeIcon icon={faMobileScreen} style={{ fontSize: '24px' }} />
    </Link>
    <Link to='/admindashboard' className="text-blue-700 bg-gray-200 ml-4">
      <FontAwesomeIcon icon={faDashboard} style={{ fontSize: '24px' }} />
    </Link>
    <Link to='/about-think5whys-home' className="text-blue-700 bg-gray-200 ml-4">
      <FontAwesomeIcon icon={faQuestionCircle} style={{ fontSize: '24px' }} />
    </Link> */}
    // <button className="text-blue-800 bg-gray-200" onClick={handleHomeClicked}>
    //   <FontAwesomeIcon icon={faUser} style={{ fontSize: '24px' }} />
    //   </button>
    // <button className="text-blue-800 bg-gray-200" onClick={handleDashboardClicked}>
    //   <FontAwesomeIcon icon={faMobileScreen} style={{ fontSize: '24px' }} />
    //   </button>
    // <button className="text-blue-800 bg-gray-200" onClick={handleAdminDashboardClicked}>
    //   <FontAwesomeIcon icon={faDashboard} style={{ fontSize: '24px' }} />
    //   </button>
    {/* <button className="text-blue-800 bg-gray-200" onClick={handleAboutThink5WhysClicked}>
      <FontAwesomeIcon icon={faQuestionCircle} style={{ fontSize: '24px' }} />
      </button> */}
  //   <button className="text-red-700 bg-gray-200" onClick={handleLogoutClick}>
  //     <FontAwesomeIcon icon={faPowerOff} style={{ fontSize: '24px' }} />
  //   </button>
  //   {logoutConfirm && (
  //     <div className="absolute right-2 w-64 p-1 bg-white border border-gray-300 shadow-lg rounded-lg z-1150">
  //       {/* <p className="text-gray-700 mb-4">Are you sure you want to logout?</p> */}
  //       <div className="flex justify-between">
  //         <button
  //           className="bg-red-600 text-white px-4 py-2 rounded-md hover:bg-red-700"
  //           onClick={handleConfirmLogoutClick}
  //         >
  //           Logout
  //         </button>
  //         <button
  //           className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-400"
  //           onClick={handleCancelLogoutClick}
  //         >
  //           Cancel
  //         </button>
  //       </div>
  //     </div>
  //   )}
  // </div>
  // <div className='w-full flex item-center justify-between py-0 px-3 cursor-pointer bg-blue-800 text-white hover:bg-green-900 transition rounded-sm'>
  //   <Link to="/rcas/add" className='sticky-menu-item'><FontAwesomeIcon icon={faExclamationCircle} style={{ marginRight: '8px' }} />+5Whys</Link>
  //   <Link to="/tasks/add" className='sticky-menu-item'><FontAwesomeIcon icon={faHourglass} style={{ marginRight: '8px' }} />+Chronicle</Link>
  //   <Link to="/applause/add" className='sticky-menu-item'><FontAwesomeIcon icon={faHandsClapping} style={{ marginRight: '8px' }} />+Applause</Link>
  // </div>
  // <div className='flex justify-center'>
  //   <AppMenu />
  // </div>
// </div> */}
